export enum AudioType {
  CHANNEL_NEW_MESSAGE = 'channel_new_message',
  CHANNEL_VOICE_ENTERING = 'channel_voice_entering',
  CHANNEL_VOICE_LEAVING = 'channel_voice_leaving',
  CHANNEL_VOICE_SCREEN_SHARING_START = 'channel_voice_screen_sharing_start',
  CHANNEL_VOICE_SCREEN_SHARING_END = 'channel_voice_screen_sharing_end',
  CHANNEL_VOICE_INVITE = 'channel_voice_invite',
  CHANNEL_VOICE_MUTE = 'channel_voice_mute',
  CHANNEL_VOICE_DEAF = 'channel_voice_deaf',
  NOTIFICATION = 'notification',
  NOTE_TAKING_START = 'noteTakingStart',
  NOTE_TAKING_END = 'noteTakingEnd',
}
